import { render, staticRenderFns } from "./ReplacementCreateDropdown.vue?vue&type=template&id=2b7a2c0c"
import script from "./ReplacementCreateDropdown.vue?vue&type=script&lang=js"
export * from "./ReplacementCreateDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports